import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot
} from '@angular/router';
import { inject } from '@angular/core';
import { StudentPerformanceDto } from '@whetstoneeducation/hero-common';
import { AppDashboardService } from '../dashboard.service';

export const teacherDashboardResolver: ResolveFn<{
  topPerformers: StudentPerformanceDto[];
  lowPerformers: StudentPerformanceDto[];
  todaySchedules: any[];
  noCalendar?: boolean;
}> = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(AppDashboardService).getTeacherDashboardResolverData();
};
